import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { StatusMessage } from '../StatusMessage/StatusMessage'
import { statusQueries } from '../../../api/status'

interface StatusMessagesProps {
  authenticated: boolean
}

export const StatusMessages = ({
  authenticated,
}: StatusMessagesProps): JSX.Element => {
  const { data } = useQuery(statusQueries.getStatusMessages())
  const { i18n } = useTranslation()

  const authenticatedMessages =
    data?.filter((message) => message.display_in_app === true) || []
  const nonAuthenticatedMessages =
    data?.filter((message) => message.display_in_app === false) || []
  const messages = authenticated
    ? authenticatedMessages
    : nonAuthenticatedMessages

  return (
    <>
      {messages.length > 0 && (
        <div className="my-4 flex flex-col gap-2">
          {messages.map((_message) => (
            <StatusMessage
              key={_message.id}
              text={i18n.language.includes('en') ? _message.en : _message.sv}
            />
          ))}
        </div>
      )}
    </>
  )
}
